<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <DialogNotice ref="dlg"></DialogNotice>
    <DialogDeleteItem ref="dlgDeleteItem" @doDelete="doDeleteFilter"></DialogDeleteItem>
    <DialogConfigMask ref="dlgSearchMaskConfig" @searchFieldConfigHasChanged="loadSearchFieldConfiguration"></DialogConfigMask>
    <SFDialog ref="filterDialog" :config="maskConfig.config" :configExt="maskConfigExt.config"></SFDialog>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      hide-overlay
      stateless
      width="350px"
      class="white"
    >
      <div justify-center fill-height v-if="!isLoading" :key="rIndex">
        <v-toolbar flat class="blue" height="40px">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-action class="mb-3" v-if="!mini">
                <v-icon color="white" class="pointer">search</v-icon>
              </v-list-tile-action>
              <v-list-tile-action class="pl-4 mb-3" v-if="mini">
                <v-tooltip top>
                  <template #activator="ttData1">
                    <v-btn v-on="ttData1.on" icon @click.stop="mini = !mini">
                      <v-icon color="white" class="pointer">chevron_right</v-icon>
                    </v-btn>
                  </template>

                  <span>{{ 'TOOLTIP_OPEN_SEARCHMASK' | translate}}</span>

                </v-tooltip>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title class="mb-3 white--text body-2" v-if="balanceName === 'Peergroup'">
                  {{ $t('TITLE_SEARCH_PEERGROUP_' + this.idModule.toUpperCase())}}
                </v-list-tile-title>
                <v-list-tile-title class="mb-3 white--text body-2" v-if="balanceName === 'Anker'">
                  {{ $t('SEARCHMASK_TITLE_' + this.idModule.toUpperCase())}}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action class="mb-3">
                <v-tooltip top>
                  <template #activator="ttData1">
                    <v-btn v-on="ttData1.on" icon @click.stop="mini = !mini">
                      <v-icon color="white" class="pointer">chevron_left</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ 'TOOLTIP_CLOSE_SEARCHMASK' | translate}}</span>
                </v-tooltip>

              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-divider></v-divider>
        <v-toolbar flat dense class="transparent" v-if="balanceName === 'Peergroup'">
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-action>
                <v-icon color="#004884"></v-icon>
              </v-list-tile-action>

              <v-list-tile-action class="mb-4 ml11">
                <v-btn
                  icon
                >
                  <v-icon color='#004884' :title="textButtSearchFilterAdmin" :text="textButtSearchFilterAdmin"
                          @click='showDialog()'>tune
                  </v-icon>
                </v-btn>
              </v-list-tile-action>
              <v-list-tile-action class="mb-4 mx-3">
                <v-btn icon>
                  <v-icon color='#004884' :title="textButtSaveSearch" :text="textButtSaveSearch" @click='showDialogSaveMAsk()'>save
                  </v-icon>
                </v-btn>
              </v-list-tile-action>

              <v-list-tile-action class="mb-4 mx-3">
                <v-btn
                  icon
                >
                  <v-icon color="#004884" @click="clear()" :text="textButtClearSearch" :title="textButtClearSearch" >clear</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-list class="pt-0" dense>
          <v-divider></v-divider>
          <v-list-tile-content>
            <v-card class="scrollCard" flat :height="maskHeight" width="350px">
              <v-card-text class="expanankerbanksuche">
                <!--<v-form>-->
                  <v-expansion-panel v-if="hasAnkerBank && ankerBankData" v-model="expandDetailPanel">
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <v-card-title primary-title class="pa-0">
                          <div>
                            <div class="body-2 ankerbanksuche">

                              {{translateName(idModule.toUpperCase() + '_ANKERBANK_DETAIL')}}</div>
                            <span>{{ankerBankData.title}}</span>
                          </div>
                        </v-card-title>
                      </template>
                      <v-card class="px-4">
                        <v-divider class="mb-2"></v-divider>
                        <span class="body-2 ankerbanksuche">{{translateName(idModule.toUpperCase() + '_ANKERBANK_DETAIL_YEAR')}}</span><br> {{ankerBankData.balance.year}}
                        <v-divider class="my-2"></v-divider>
                        <span class="body-2 ankerbanksuche">{{translateName(idModule.toUpperCase() + '_ANKERBANK_DETAIL_JURISDICTION')}}</span><br> {{getRKreis(ankerBankData.balance.rkNr).title}}<br>
                        <v-divider class="my-2"></v-divider>
                        <span class="body-2 ankerbanksuche">{{translateName(idModule.toUpperCase() + '_ANKERBANK_DETAIL_AA')}}</span><br> {{getAbschlussArt(ankerBankData.balance.aaNr).titleLong}}<br>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                <v-container>
                  <v-layout row v-if="balanceName === 'Peergroup'">
                    <v-flex md7>
                      <v-select v-model="searchConfig"
                                @change="onChangeSearchConfig"
                                :items="mySearchConfigs"
                                item-text="text"
                                item-value="id"
                                :clearable="true"
                                :label="labelSearch"
                      ></v-select>
                    </v-flex>
                    <v-flex md4>
                      <v-layout row style="padding-top: 14px;">
                        <v-card class="ml-2 pa-1 handpointer" tile @click='deleteFilter()'>
                          <v-icon class='handpointer' :disabled="!searchConfig" color='#e05469' :title="textButtRemove" :text="textButtRemove" @click='deleteFilter()'>delete</v-icon><br>
                        </v-card>
                        <v-card class="ml-1 pa-1 handpointer" tile @click='exportFilter()'>
                          <v-icon class='handpointer' :disabled="!searchConfig" color='#004884' :title="textButtExport" :text="textButtExport" >archive</v-icon>
                        </v-card>
                        <v-card class="ml-1 pa-1 handpointer" tile @click='pickFile()'>
                          <v-icon class='handpointer' color='#004884' :title="textButtUpload" :text="textButtUpload" >publish</v-icon>
                        </v-card>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout row justify-center v-if="balanceName === 'Peergroup'">
                    <input
                      type="file"
                      style="display: none"
                      ref="image"
                      accept=".json"
                      @change="onFilePicked"
                    >
                  </v-layout>
                  <v-layout row wrap fluid justify-space-around v-if="showMask">
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap class='searchMaskRow' v-for='header in maskConfig.rows' :key='header.index'>
                        <v-flex xs12 sm12 md12 class='searchMaskCell paddingrl'>
                          <sitem ref="sitem" eventName='onSumbitMask2' :abff='abFilterFields' :header='header'
                                 :data='header.arr[0]' v-if='header.arr.length>0'></sitem>
                        </v-flex>
                        <v-flex xs12 sm12 md12 class='searchMaskCell paddingrl'>
                          <sitem ref="sitem" eventName='onSumbitMask2' :abff='abFilterFields' :header='header'
                                 :data='header.arr[1]' v-if='header.arr.length>1'></sitem>
                        </v-flex>
                        <v-flex xs12 sm12 md12 class='searchMaskCell paddingrl'>
                          <sitem ref="sitem" eventName='onSumbitMask2' :abff='abFilterFields' :header='header'
                                 :data='header.arr[2]' v-if='header.arr.length>2'></sitem>
                        </v-flex>
                        <v-flex xs12 sm12 md12 class='searchMaskCell paddingrl'>
                          <sitem ref="sitem" eventName='onSumbitMask2' :abff='abFilterFields' :header='header'
                                 :data='header.arr[3]' v-if='header.arr.length>3'></sitem>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="!isPeerGroupSearch && isAllowedShowEntriesWithoutBalance">
                    <v-checkbox color="#004884" :label='checkboxTextBalanceAvailable' v-model='showEntriesWithoutBalance' @change="onChangeEnableWithoutBalance"></v-checkbox>
                  </v-layout>
                  <v-layout row v-if="hasAnkerBank">
                    <!--<v-checkbox :label='checkboxText' @change="changeYearBefore" v-model='useYearBefore'></v-checkbox>-->
                    <v-btn outline class="text-none" color="#004884" @click.native="changeYearBefore()" small block>
                      {{ checkboxText }}
                    </v-btn>
                  </v-layout>
                </v-container>
                <!--</v-form>-->
              </v-card-text>
            </v-card>
          </v-list-tile-content>
          <v-list-tile-action class="white" style="height:54px;" v-if="false">
            <v-layout row justify-space-around class="">
              <v-checkbox color="#004884" label='Schnitzler Filter' v-model='dummySchnitzlerFilter'></v-checkbox>
              <v-checkbox color="#004884" label='Letztes Jahr' v-model='dummyLastYearOnly'></v-checkbox>
            </v-layout>
          </v-list-tile-action>
          <v-list-tile-action class="white" style="height:54px; padding-bottom: 10px;">
            <v-layout row justify-space-around style="padding-top: 32px;">
              <v-btn v-if="!mini" outline class="text-none" color="#004884" @click.native="submitToExcel()" small>
                {{ 'BUTT_SUBMIT_EXCEL' | translate}}
              </v-btn>
              <v-btn v-if="!mini" dark class="text-none blue" @click.native="submit()" small>
                {{ 'BUTT_SUBMIT' | translate}}
              </v-btn>
            </v-layout>

          </v-list-tile-action>
        </v-list>
      </div>
      <div justify-center fill-height v-if="isLoading">
        <v-toolbar flat class="blue" height="40px">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-action class="mb-3" v-if="!mini">
                <v-icon color="white" class="pointer">search</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="mb-3 white--text body-2" v-if="balanceName === 'Peergroup'">
                  {{ $t('TITLE_SEARCH_PEERGROUP_' + this.idModule.toUpperCase())}}
                </v-list-tile-title>
                <v-list-tile-title class="mb-3 white--text body-2" v-if="balanceName === 'Anker'">
                  {{ $t('SEARCHMASK_TITLE_' + this.idModule.toUpperCase())}}
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action class="mb-3">
                <v-btn
                  icon
                  @click.stop="mini = !mini"
                >
                  <v-icon color="white">chevron_left</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-divider></v-divider>
        <v-container>
          <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </v-container>
      </div>
    </v-navigation-drawer>
    <v-dialog v-model="dialogSearchField" persistent max-width="500px">
      <v-card>
        <v-card color="blue">
          <v-card-title flat class='white--text subheading'>{{ 'SEARCH_MASK_NAME' | translate}}</v-card-title>
        </v-card>
        <!--<v-card-title>
          <span class="headline">{{ 'SEARCH_MASK_NAME' | translate}}</span>
        </v-card-title>-->
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field v-model="maskName" :label="Searchmaskname" required></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>

          <v-btn color="#004884" small outline dark class="text-none" @click.native="dialogSearchField = false">{{
            'BUTT_CANCEL' |
            translate}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#004884" small dark class="text-none" @click.native="saveMask">{{ 'BUTT_SAVE' | translate}}
          </v-btn>

          <!--<v-btn color="blue darken-1" flat @click.native="dialogSearchField = false">{{ 'BUTT_CANCEL' |
            translate}}
          </v-btn>
          <v-btn color="blue darken-1" flat @click.native="saveMask">{{ 'BUTT_SAVE' | translate}}</v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import sitem from './SItem'
  import swal from 'sweetalert2/dist/sweetalert2.js'
  import DialogConfigMask from '@/components/module/dialogs/DialogConfigMask.vue'
  import SFDialog from '../dialogs/DialogSearchFields'
  import HitlistCounter from '../../widgets/HitlistCounter'
  import { SelfBuildingSquareSpinner } from 'epic-spinners'
  import DialogNotice from "../dialogs/DialogNotice";
  import DialogDeleteItem from "../dialogs/DialogDeleteItem";
  var $ = require('jquery')
  var _ = require('lodash')
  var base64 = require('base-64')
  export default {
    components: {DialogDeleteItem, DialogNotice, HitlistCounter, sitem, DialogConfigMask, SelfBuildingSquareSpinner, SFDialog},
    name: 'SearchMaskv2',
    props: ['configName', 'tableName', 'eventName', 'eventNameSubmit', 'ankerBank', 'balanceName'],
    data() {
      return {
        textButtExport: Vue.i18n.translate('BUTT_EXPORT'),
        textButtRemove: Vue.i18n.translate('BUTT_FILTERSET_DELETE'),
        textButtUpload: Vue.i18n.translate('BUTT_IMPORT'),
        rIndex: 0,
        expandDetailPanel: null,
        labelAll: 'Alle',
        idModule: '',
        divId: 1,
        idModuleName: '',
        drawer: true,
        isLoading: true,
        items: [
          {title: 'Home', icon: 'dashboard'},
          {title: 'About', icon: 'question_answer'}
        ],
        Searchmaskname: Vue.i18n.translate('LABEL_SEARCHMASKNAME'),
        mini: false,
        right: null,
        ankerBankData: null,
        bottomNav: 1,
        dummyLastYearOnly: true,
        dummySchnitzlerFilter: true,
        hitListConfig: [],
        maskDataName: 'maskData',
        maskHeight: 480,
        textButtSaveSearch: Vue.i18n.translate('BUTT_SAVE_SEARCH'),
        textButtClearSearch: Vue.i18n.translate('BUTT_CLEAR_SEARCH'),
        textButtSearchFilterAdmin: Vue.i18n.translate('BUTT_SEARCH_FILTER_ADMIN'),
        dialogSearchField: false,
        searchConfig: null,
        allowClearSearch: false,
        checkboxText: Vue.i18n.translate('FINANCIAL_YEAR_BANK_' + Vue.prototype.$api.getModuleId().toUpperCase()),
        toggleAll: false,
        show: true,
        target: '',
        dialog: false,
        stopEventSearch: false,
        labelSearch: Vue.i18n.translate('TITLE_SEARCH_PEERGROUP'),
        mySearchConfigs: [],
        'searchData': {},
        lastYearOnly: false,
        isPeerGroupSearch: false,
        akresults: [],
        countries: [],
        attributeNameDynamic: 'dynamic',
        useYearBefore: false,
        useYearBeforeVisuell: false,
        showMask: false,
        selectErrors: null,
        searchMaskConfig: {},
        regionList: [],
        branchList: [],
        maskName: '',
        ttData1: {},
        maskId: -1,
        przList: [
          {'title': '10', 'id': '10'},
          {'title': '20', 'id': '20'},
          {'title': '30', 'id': '30'},
          {'title': '40', 'id': '40'},
          {'title': '50', 'id': '50'},
          {'title': '60', 'id': '60'},
          {'title': '70', 'id': '70'},
          {'title': '80', 'id': '80'},
          {'title': '90', 'id': '90'},
          {'title': '100', 'id': '100'}
        ],
        maskConfig: {
          leftCheckboxes: [],
          isDynamic: false,
          entries: [],
          config: [],
          rows: []
        },
        checkboxTextBalanceAvailable: Vue.i18n.translate('TITLE_CHECKBOX_WO_BALANCE'),
        showEntriesWithoutBalance: false,
        isAllowedShowEntriesWithoutBalance: false,
        hasAnkerBank: false,
        abFilterFields: [],
        configLoaded: false,
        maskConfigExt: {
          config: []
        }
      }
    },
    computed: {
      filter () {
        return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
      }

      /*
      filteredItems () {
        return this.maskConfig.entries.filter(item => {
          return item.dynamic === '0'
        })
      }
      */
    },
    watch: {
      mini: function (value) {
        this.mini = value
        this.$emit('collapseEvent', this.mini)
      },
      useYearBefore: function (value) {
        this.useYearBefore = value
        this.updateSearchMask()
      }
    },
    methods: {
      translateName : function (key) {
        return Vue.i18n.translate(key)
      },
      getAbschlussArt: function (nr) {
        let art = Vue.prototype.storage.getAbschlussartByNr(nr)
        return art
      },
      getRKreis: function (nr) {
        let kreis = Vue.prototype.storage.getRechtskreisByNr(nr)
        return kreis
      },
      onChangeEnableWithoutBalance: function () {
        let pd = Vue.prototype.$api.getParamData()
        if (this.showEntriesWithoutBalance) {
          pd.enableWithoutBalance = 1
        } else {
          pd.enableWithoutBalance = 0
        }
        Vue.prototype.$api.updateParamData(pd)
      },
      exportFilter () {
        Vue.prototype.$api.debug('exportFilter')
        var arr = []
        arr.push(this.searchConfig)
        Vue.prototype.$api.exportSearchFieldConfigurations(arr)
      },
      OnResize: function () {
        var view = Vue.prototype.$api.viewport()
        var footerHeight = 35
        var headerHeight = 65
        var titleHeightOfMask = 95
        var h2 = view.height - footerHeight - headerHeight - titleHeightOfMask - 60
        this.maskHeight = h2
      },
      getConfigByName(name) {
        for (var index in this.maskConfig.config) {
          var entry = this.maskConfig.config[index]
          if (entry.field === name) return entry
        }
        return null
      },
      changeLastYear() {
        this.stopEventSearch = false
        this.lastYearOnly = !this.lastYearOnly
        Vue.prototype.$api.debug('submit', 'changeLastYear')
        this.submit()
      },
      changeYearBefore() {
        this.stopEventSearch = false
        this.useYearBefore = !this.useYearBefore
        Vue.prototype.$api.debug('submit', 'changeYearBefore')
        this.submit()
      },
      deleteSearchMask() {
        Vue.prototype.$api.debug('deleteSearchMask')
        var data = {
          'id': this.maskId
        }
        Vue.prototype.$api.deleteSearchFieldConfigurations(null, data, this.onConfigSaved)
      },
      saveMask() {
        Vue.prototype.storage.maskData = []
        var searchData = Vue.prototype.$api.createSearchDataFromFields(this, this.headerFields)
        this.dialogSearchField = false
        searchData.maskName = this.maskName
        var alreadyExists = false
        for (var index in this.mySearchConfigs) {
          var item = this.mySearchConfigs[index]
          Vue.prototype.$api.debug(item)
          if (item.text === searchData.maskName) {
            alreadyExists = true
          }
        }
        if (alreadyExists) {
          alert(Vue.i18n.translate('ALERT_SEARCHMASK'))
          return
        }
        // console.log('searchData', searchData)
        Vue.prototype.$api.saveSearchFieldConfigurations(searchData, this.onConfigSaved)
      },
      onConfigSaved(data) {
        Vue.prototype.$api.debug('onConfigSaved' + this.maskName, data)
        Vue.prototype.$api.getSearchFieldConfigurations(this.onGetSearchConfigurations)
      },
      getTxtForSwitch() {
        if (!this.lastYearOnly) {
          return 'Alle Jahre werden angezeigt'
        } else {
          return 'Neuestes Jahr wird angezeigt'
        }
      },
      addMaskField() {
        Vue.prototype.$api.debug('addMaskField')
        this.dialog = true
      },
      showDialogSaveMAsk() {
        this.maskName = ''
        this.dialogSearchField = true
      },
      showDialog() {
        this.dialog = true
        Vue.prototype.$eventHub.$emit('EventStoreSearchData')
        this.$refs.dlgSearchMaskConfig.show()
      },
      showDialogExport() {
        this.dialog = true
        Vue.prototype.$eventHub.$emit('EventStoreSearchData')
        this.$refs.filterDialog.show()
      },
      onGetData(data) {
        Vue.prototype.$api.debug('onGetData', data)
      },
      onAddField(model) {
        Vue.prototype.$api.debug('onAddField', model)
        model.dynamic = 0
        this.$forceUpdate()
      },

      onGetDownload(data) {
        Vue.prototype.$api.hideIdle()
      },
      onGetHitList(data) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit(this.$props.eventName, data)
      },
      createSearchDataFromFields() {
        var searchData = {
          lastYear: this.lastYearOnly
        }
        var hasAddItems = false
        for (var rowIndex in this.maskConfig.rows) {
          var row = this.maskConfig.rows[rowIndex]
          for (var aIndex in row.arr) {
            var data = row.arr[aIndex]
            if (data.value) {
              if (data.field === 'year') {
                if (('' + data.value).indexOf(',') > -1) {
                  data.value = ('' + data.value).split(',')
                }
              }
              if (data.value === '-') continue
              Vue.prototype.storage.maskData[data.field] = data.value
              searchData[data.field] = data.value
              hasAddItems = true
            }
          }
        }
        // Vue.prototype.$api.debug('stored data', Vue.prototype.storage.maskData)
        if (this.allowClearSearch) {
          //
        } else {
          if (!hasAddItems) {
            return null
          }
        }
        return searchData
      },
      submitAnkerSearch() {
        Vue.prototype.$api.debug('submitAnkerSearch', Vue.prototype.storage.maskData)
        var cmp = this
        // Vue.prototype.storage.maskData = []
        var result = Vue.prototype.$api.createSearchDataFromFields(this, this.headerFields)
        cmp.searchData = result.searchData

        if (cmp.dummySchnitzlerFilter) {
          cmp.searchData.schnitzler = 1
        } else {
          cmp.searchData.schnitzler = 0
        }
        if (cmp.dummyLastYearOnly) {
          cmp.searchData.lastYear = true
        } else {
          cmp.searchData.lastYear = false
        }


        // Vue.prototype.$api.debug('Vue.prototype.storage.maskData', searchData)
//      Vue.prototype.storage.saveState(cmp.maskDataName, cmp.searchData)
        /*
        if (!result.hasAddItems) {
          var datas = {
            array: [],
            maxsize: 0,
            size: 0
          }
          this.onGetHitList(datas)
        } else {
          Vue.prototype.$eventHub.$emit(this.$props.eventNameSubmit, cmp.searchData)
          Vue.prototype.$api.searchBanks(cmp.searchData, this.onGetHitList, Vue.prototype.$api.onFailure)
        }*/
        Vue.prototype.$eventHub.$emit(this.$props.eventNameSubmit, cmp.searchData)
        Vue.prototype.$api.searchBanks(cmp.searchData, this.onGetHitList, Vue.prototype.$api.onFailure)
      },
      submitAnkerSearchExcelPeergroup() {
        Vue.prototype.$api.debug('submitAnkerSearchExcelPeergroup')
        var cmp = this
        Vue.prototype.storage.maskData = []
        var result = Vue.prototype.$api.createSearchDataFromFields(this, this.headerFields)
        cmp.searchData = result.searchData
        cmp.searchData['createExcel'] = 1
        cmp.searchData.hitListConfig = []
        cmp.searchData.schnitzler = 0
        // Vue.prototype.$api.debug('Vue.prototype.storage.maskData', searchData)
        // Vue.prototype.storage.saveState(cmp.maskDataName, cmp.searchData)
        result.hasAddItems = true
        let hideColumns = []
        let headerConfigName = cmp.configName + 'TC'
        let columns = Vue.prototype.storage.getStorage(headerConfigName,null)
        // console.log('columns', headerConfigName, columns)
        if (columns && columns.length > 0) {
          _.forEach(columns, function (col) {
            if (!col.isVisible) {
              hideColumns.push(col.meta.id)
            }
          })
        }
        // console.log('hideColumns', hideColumns)
        if( hideColumns.length > 0) {
          cmp.searchData.excelHideColumns = hideColumns.join(',')
        }

        if (!result.hasAddItems) {
          var datas = {
            array: [],
            maxsize: 0,
            size: 0
          }
          this.onGetHitList(datas)
        } else {
          Vue.prototype.$eventHub.$emit(this.$props.eventNameSubmit, cmp.searchData)
          Vue.prototype.$api.searchBanksPeergroup(cmp.searchData, this.onGetDownload, Vue.prototype.$api.onFailure)
        }
      },
      submitAnkerSearchExcel() {
        Vue.prototype.$api.debug('submitAnkerSearchExcel')
        var cmp = this
        Vue.prototype.storage.maskData = []
        var result = Vue.prototype.$api.createSearchDataFromFields(this, this.headerFields)
        cmp.searchData = result.searchData
        cmp.searchData['createExcel'] = 1
        cmp.searchData.hitListConfig = []
        cmp.searchData.schnitzler = 0
        // Vue.prototype.$api.debug('Vue.prototype.storage.maskData', searchData)
        // Vue.prototype.storage.saveState(cmp.maskDataName, cmp.searchData)
        result.hasAddItems = true
        let hideColumns = []
        let headerConfigName = cmp.configName + 'TC'
        let columns = Vue.prototype.storage.getStorage(headerConfigName,null)
        // console.log('columns', headerConfigName, columns)
        if (columns && columns.length > 0) {
          _.forEach(columns, function (col) {
            if (!col.isVisible) {
              hideColumns.push(col.meta.id)
            }
          })
        }
        console.log('hideColumns', hideColumns)
        if( hideColumns.length > 0) {
          cmp.searchData.excelHideColumns = hideColumns.join(',')
        }
        if (!result.hasAddItems) {
          var datas = {
            array: [],
            maxsize: 0,
            size: 0
          }
          this.onGetHitList(datas)
        } else {
          Vue.prototype.$eventHub.$emit(this.$props.eventNameSubmit, cmp.searchData)
          Vue.prototype.$api.searchBanks(cmp.searchData, this.onGetDownload, Vue.prototype.$api.onFailure)
        }
      },
      submitPeergroupSearch() {
        Vue.prototype.$api.debug('submitPeergroupSearch')
        if (this.stopEventSearch) {
          Vue.prototype.$api.debug('submit canceled')
          return
        }
        Vue.prototype.storage.maskData = []
        var cmp = this
        var result = Vue.prototype.$api.createSearchDataFromFields(this, this.headerFields)
        cmp.searchData = result.searchData
        if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
          cmp.searchData.ankerBank = Vue.prototype.$api.balanceToString(Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()))
        }


        if ((cmp.searchData === null) && (!this.allowClearSearch)) {
          var datas = {
            array: [],
            maxsize: 0,
            size: 0
          }
          this.onGetHitList(datas)
        } else {
          if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
            cmp.searchData.ankerBankCrefoNr = Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()).crefoNr
          } else {
            cmp.hasAnkerBank = false
          }
          cmp.searchData.hitListConfig = this.hitListConfig

          if (cmp.dummySchnitzlerFilter) {
            cmp.searchData.schnitzler = 1
          } else {
            cmp.searchData.schnitzler = 0
          }
          cmp.searchData.schnitzler = 0
          if (Vue.prototype.storage.multipleYears) {
            cmp.searchData.schnitzler = 1
          }

          cmp.searchData.currency = Vue.prototype.storage.getCurrency()
          cmp.searchData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()


          if (cmp.dummyLastYearOnly) {
            cmp.searchData.lastYear = true
          } else {
            cmp.searchData.lastYear = false
          }
          // Vue.prototype.storage.saveState(cmp.maskDataName, Vue.prototype.storage.maskData)
          this.$nextTick(function () {
            Vue.prototype.$eventHub.$emit(this.$props.eventNameSubmit, cmp.searchData)
            Vue.prototype.$api.searchBanksPeergroup(cmp.searchData, cmp.onGetHitList, Vue.prototype.$api.onFailure)
          })
        }
      },
      submitPeergroupSearchExcel() {
        Vue.prototype.$api.debug('submitPeergroupSearchExcel')
        if (this.stopEventSearch) {
          Vue.prototype.$api.debug('submit canceled')
          return
        }
        Vue.prototype.storage.maskData = []
        var cmp = this
        var result = Vue.prototype.$api.createSearchDataFromFields(this, this.headerFields)
        cmp.searchData = result.searchData
        if (this.ankerBank) {
          cmp.searchData.ankerBank = Vue.prototype.$api.balanceToString(this.ankerBank)
        }
        cmp.searchData['createExcel'] = 1


        if ((cmp.searchData === null) && (!this.allowClearSearch)) {
          var datas = {
            array: [],
            maxsize: 0,
            size: 0
          }
          this.onGetHitList(datas)
        } else {
          if (this.hasAnkerBank) {
            /*
            aaNr: cmp.$route.params.aaNr,
            crefoNr: cmp.$route.params.crefoNr,
            rkNr: cmp.$route.params.rkNr,
            source: cmp.$route.params.source,
            year: cmp.$route.params.year,
             */

            cmp.searchData.ankerBankCrefoNr = this.ankerBank.crefoNr
            // cmp.searchData.ankerBankHgpNr = this.ankerBank.hgpNr
            // cmp.searchData.ankerBankGuid = this.ankerBank.guid
          }
          cmp.searchData.hitListConfig = this.hitListConfig
          this.$nextTick(function () {
            Vue.prototype.$eventHub.$emit(this.$props.eventNameSubmit, cmp.searchData)
            Vue.prototype.$api.searchBanksPeergroup(cmp.searchData, cmp.onGetHitList, Vue.prototype.$api.onFailure)
          })
        }
      },
      submit() {
        Vue.prototype.$api.showIdle()
        this.$emit('onSubmit')
        if (this.balanceName === 'Anker') {
          this.submitAnkerSearch()
        } else {
          this.submitPeergroupSearch()
        }
      },
      submitToExcel() {
        if (!Vue.prototype.$api.hasProduct('hasRightExport')) {
          Vue.prototype.$api.debug('missing right to export files')
          this.$refs.dlg.show({
            title: Vue.i18n.translate('DIALOG_TITLE_MISSING_HAS_EXPORT'),
            text: Vue.i18n.translate('DIALOG_TEXT_MISSING_HAS_EXPORT')
          })
          return
        }

        Vue.prototype.$api.showIdle()

        if (this.balanceName === 'Anker') {
          this.submitAnkerSearchExcel()
        } else {
          this.submitAnkerSearchExcelPeergroup()
        }

      },

      clear() {
        Vue.prototype.$api.debug('clear')
        for (var rowIndex in this.maskConfig.rows) {
          var row = this.maskConfig.rows[rowIndex]
          for (var aIndex in row.arr) {
            var data = row.arr[aIndex]
            data.value = ''
          }
        }
        Vue.prototype.$eventHub.$emit('clearAllSearchFields', null)
      },
      updateSearchMask(doSubmit) {
        var cmp = this
        this.showMask = false
        this.dialog = false
        var sendDoSubmit = doSubmit
        this.$nextTick(function () {
          if (cmp.ankerBank) {
            if (!cmp.useYearBefore) {
              Vue.prototype.storage.maskData['year'] = cmp.ankerBank.year
            } else {
              Vue.prototype.storage.maskData['year'] = ((cmp.ankerBank.year * 1) + 1) + ', ' + cmp.ankerBank.year + ', ' + ((cmp.ankerBank.year * 1) - 1)
            }
            Vue.prototype.$eventHub.$emit('otherYearSelected', Vue.prototype.storage.maskData['year'])
          }
          cmp.refreshLayout()
          cmp.$nextTick(function () {
            for (var i in cmp.$refs['sitem']) {
              var item = cmp.$refs['sitem'][i]
              item.reload()
            }
            if (sendDoSubmit) {
              Vue.prototype.$api.debug('submit', 'sendDoSubmit')
              cmp.submit()
            }
          })
        })
      },
      refreshLayout() {
        Vue.prototype.$api.debug('refreshLayout', this.maskConfig.config, Vue.prototype.storage.maskData)
        var cmp = this
        var foundData = false
        var data = []
        this.hitListConfig = []
        for (var index2 in this.maskConfig.config) {
          var entry2 = this.maskConfig.config[index2]
          entry2.isAbsolute = entry2.type === '3'
          data.push(entry2)
        }
        for (var index in this.maskConfigExt.config) {
          var entry = this.maskConfigExt.config[index]
          entry.isAbsolute = entry.type === '3'
          data.push(entry)
        }
        var rows = []
        var e = {
          arr: []
        }
        cmp.rowItems = []
        index = 0
        for (var rowIndex in data) {
          var rowItem = {}
          rowItem.isEnabled = data[rowIndex].isEnabled
          var dataItem = data[rowIndex]
          rowItem.mask = ''
          rowItem.type = 'textfield'
          rowItem.dbType = dataItem.type
          rowItem.isAbsolute = true
          rowItem.unit = dataItem.unit
          rowItem.dimension = dataItem.dimension
          rowItem.meta = dataItem
          rowItem.field = data[rowIndex].field

          dataItem.isStandard = (dataItem.type != 'sp') && (dataItem.type != 'kz')
          if (dataItem.isStandard) {
            rowItem.title = data[rowIndex].title
            rowItem.text = Vue.prototype.$api.onGetI18NValue(data[rowIndex].title)
            rowItem.isStandard = true

          } else {
            rowItem.isStandard = false
            rowItem.type = 'fromto'
            rowItem.title = dataItem.name
            rowItem.text = dataItem.name

            if (dataItem.isAbsolute) {
              rowItem.type = 'fromto'
              rowItem.przBaseValue = dataItem.value
              // rowItem.field = 'abs|' + rowItem.field + '|' + dataItem.type
              // Vue.prototype.storage.maskData
              // rowItem.field = data[rowIndex].id
              rowItem.defaultValue = Vue.prototype.storage.maskData[rowItem.field]

            } else {
              // rowItem.type = 'fromtoprz'
              rowItem.przBaseValue = dataItem.value
              // rowItem.field = 'prz|' + rowItem.field + '|' + dataItem.type
              // Vue.prototype.storage.maskData
              // rowItem.field = data[rowIndex].id
              rowItem.defaultValue = Vue.prototype.storage.maskData[rowItem.field]
            }

            if (cmp.searchData) {
              rowItem.defaultValue = cmp.searchData[rowItem.field]
            } else {
              rowItem.defaultValue = ''
            }
            /*
            if (rowItem.isEnabled) {
              this.hitListConfig.push({
                title: dataItem.name.trim(),
                id: dataItem.id,
                type: dataItem.type
              })
            }
             */
          }
          if (rowItem.dbType === 'STATE') {
            rowItem.type = 'checkbox'
          }
          rowItem.isDynamic = data[rowIndex][this.attributeNameDynamic] === '2'
          rowItem.hidden = data[rowIndex].isHidden
          rowItem.index = index
          rowItem.fType = data[rowIndex].type
          rowItem.dbType = dataItem.type
          rowItem.fieldType = dataItem.type

          Vue.prototype.$api.fillRowItem(cmp, rowItem)

          cmp.rowItems['' + rowItem.field] = rowItem

          var itemField = rowItem.field.split('|')
          if (Vue.prototype.storage.abFilterFields) {
            var key = rowItem.field
            rowItem.abValue = Vue.prototype.storage.abFilterFields[key]
            Vue.prototype.$api.debug('abFilterFields - ' + key + ' = ' + rowItem.abValue)
          }


          if (rowItem.value) {
            foundData = true
          }
          if (!data[rowIndex].isEnabled) {
            continue
          }
          if (Vue.prototype.storage.maskData[rowItem.field]) {
            rowItem.value = Vue.prototype.storage.maskData[rowItem.field]
            // Vue.prototype.$api.debug('get default value for ' + rowItem.field + ' = ' + rowItem.value)
          }
          var left = e.arr.length <= 3
          if (left) {
            e.arr.push(rowItem)
          } else {
            rows.push(e)
            e = {
              arr: []
            }
            e.arr.push(rowItem)
            index++
          }
          left = !left
        }
        if (e.arr.length > 0) {
          rows.push(e)
        }
        this.maskConfig.rows = rows
        cmp.showMask = true
        Vue.prototype.$eventHub.$emit('OnGetExtraFieldsHitListConfig', this.hitListConfig)
        return foundData
      },
      onKeyUp() {
        Vue.prototype.$api.debug('submit', 'onKeyUp')
        this.submit()
      },
      onGetSearchMaskConfig(data) {
        Vue.prototype.$api.debug('onGetSearchMaskConfig', data)
        var cmp = this
        this.searchMaskConfig = data.array
        this.maskConfig.leftCheckboxes = []
        this.maskConfig.config = []
        this.maskConfig.rows = []
        Vue.prototype.storage.abFilterFields = data.baseData
        var index = 0
        for (var rowIndex in this.searchMaskConfig) {
          var entry = this.searchMaskConfig[rowIndex]
          entry.field = this.searchMaskConfig[rowIndex].id
          entry.id = rowIndex
          entry.isStandard = true
          entry.isDynamic = false
          entry.isHidden = false
          entry.isEnabled = true

          entry.index = index

          entry.title = this.searchMaskConfig[rowIndex].name
          entry.text = this.searchMaskConfig[rowIndex].name
          entry.value = Vue.prototype.storage.maskData[entry.field]
          entry.fieldType = this.searchMaskConfig[rowIndex].type
          entry.orderNr = this.searchMaskConfig[rowIndex].orderNr
          entry.unit = this.searchMaskConfig[rowIndex].unit

          index++

          this.maskConfig.config.push(entry)
          this.maskConfig.leftCheckboxes.push(entry)
        }
        this.refreshLayout()
        this.configLoaded = true
        this.onDataLoaded(this.dataLoadedIndex + 1)
        Vue.prototype.storage.saveState('searchMaskConfig', this.maskConfig)

      },
      onPRZToAnkerbank(data) {
        var bbs = 0
        if (Vue.prototype.storage.ankerBank) {
          bbs = Vue.prototype.storage.ankerBank.balanceSum
        }
        if (Vue.prototype.storage.ankerBank) {
          this.rowItems['balanceSumTo'].value = Math.round((bbs * 0.00000001) * data.value)
          Vue.prototype.storage.maskData['balanceSumTo'] = this.rowItems['balanceSumTo'].value
          Vue.prototype.$eventHub.$emit('otherSumSelected', {
            'balanceSumTo': Vue.prototype.storage.maskData['balanceSumTo'],
            'balanceSumFrom': Vue.prototype.storage.maskData['balanceSumFrom']
          })
        }
      },
      onSumbitMask2() {
        var cmp = this
        this.$nextTick(function () {
          cmp.submit()
        })
      },
      onSumbitClear() {
        var cmp = this
        this.$nextTick(function () {
          cmp.allowClearSearch = true
          cmp.submit()
          cmp.allowClearSearch = false
        })
      },
      onDoSearch() {
        this.submit()
      },
      onChangeSearchMask(data, dataExt) {
        this.dialog = false
        this.maskConfig.config = data
        this.maskConfigExt.config = dataExt
        Vue.prototype.storage.maskConfig = data
        Vue.prototype.storage.maskConfigExt = dataExt

        Vue.prototype.storage.saveState('maskConfig', data)
        Vue.prototype.storage.saveState('maskConfigExt', dataExt)
        this.updateSearchMask(true)
      },
      onPRZFromAnkerbank(data) {
        var bbs = 0
        if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
          bbs = Vue.prototype.storage.getAnkerbankData(Vue.prototype.$api.getModuleId()).balanceSum
          this.rowItems['balanceSumFrom'].value = Math.round((bbs * 0.00000001) * data.value)
          Vue.prototype.storage.maskData['balanceSumFrom'] = this.rowItems['balanceSumFrom'].value
          Vue.prototype.$eventHub.$emit('otherSumSelected', {
            'balanceSumTo': Vue.prototype.storage.maskData['balanceSumTo'],
            'balanceSumFrom': Vue.prototype.storage.maskData['balanceSumFrom']
          })
        }
      },
      onGetHitListConfig(data) {
        this.headerFields = data.array
        Vue.prototype.storage.currentHeaderFields = data.array
      },
      loadSearchFieldConfiguration (data) {
        this.showMask = false
        Vue.prototype.$api.debug('loadSearchFieldConfiguration', data)
        Vue.prototype.$api.getAvailableSearchFieldColumnsForUser(-1, -1, this.target, this.onGetSearchMaskConfig)
      },
      onDataLoaded(index) {
        Vue.prototype.$api.debug('onDataLoaded', index)
        if (index === 0) {
          Vue.prototype.$api.getAvailableSearchFieldColumnsForUser(-1, -1, this.target, this.onGetSearchMaskConfig)
        } else if (index === 1) {
          Vue.prototype.$api.getAvailableHitListColumnsForUser(-1, -1, this.target, this.onGetHitListConfig)
        }
        this.dataLoadedIndex = index
      },
      onGetFilterFields(data) {
        Vue.prototype.$api.debug('onGetFilterFields')
        for (var index in data.array) {
          var item = data.array[index]
          if (item) {
            if (!Object.prototype.hasOwnProperty.call(item, 'unit')) {
              item.unit = 2
            }
          }
        }
        this.abFilterFields = data.data
        this.maskConfigExt.config = data.array

        if (Vue.prototype.storage.maskConfig) {
          var cmp = this
          cmp.maskConfig.config = Vue.prototype.storage.getStorage('maskConfig', Vue.prototype.storage.maskConfig)
          cmp.maskConfigExt.config = Vue.prototype.storage.getStorage('maskConfigExt', Vue.prototype.storage.maskConfigExt)

          Vue.prototype.$api.debug('onGetFilterFields', cmp.maskConfig.config, cmp.maskConfigExt.config)
          this.$nextTick(function () {
            // cmp.updateSearchMask(false)
            cmp.refreshLayout()
          })
        }
      },
      onGetSearchConfigurations: function (data) {
        Vue.prototype.$api.debug('mySearchConfigs', data)
        this.mySearchConfigs = data
        this.isLoading = false
        Vue.prototype.$api.hideIdle()
      },
      getById(id) {
        for (var index in this.mySearchConfigs) {
          var item = this.mySearchConfigs[index]
          if (item.id === id) return item
        }
        return null
      },
      onChangeSearchConfig(config) {
        var sc = this.getById(this.searchConfig)
        if (sc === null) {
          Vue.prototype.$eventHub.$emit('updateAllSearchFields', null)
          return
        }
        this.maskId = sc.id
        this.maskName = sc.text
        Vue.prototype.$api.debug('onChangeSearchConfig', config, sc)
        try {
          var fields = JSON.parse(sc.searchMaskFields)
          // console.log('SC', sc, fields)
          Vue.prototype.$eventHub.$emit('updateAllSearchFields', fields)
        } catch (exception) {
          Vue.prototype.$eventHub.$emit('updateAllSearchFields', null)
        }
      },
      resetCheckNoBalance () {
        this.showEntriesWithoutBalance = false
        let pd = Vue.prototype.$api.getParamData()
        pd.enableWithoutBalance = 0
        Vue.prototype.$api.updateParamData(pd)
      },
      onMountedDone() {
        var cmp = this
        this.expandDetailPanel = null

        this.rechtskreise = []
        this.labelAll = Vue.i18n.translate('LABEL_DD_ALL')
        this.isAllowedShowEntriesWithoutBalance = Vue.prototype.$api.getParamData().enableWithoutBalance === 1
        this.resetCheckNoBalance()
        cmp.onDataLoaded(0)
        cmp.labelSearchField = Vue.i18n.translate('labelSearchField')
        this.isLoading = true
        this.$nextTick(function () {
          Vue.prototype.$api.showIdle()
          Vue.prototype.$api.getSearchFieldConfigurations(cmp.onGetSearchConfigurations)
          if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
            var data = Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()) // mefix 2502
            Vue.prototype.storage.maskData['year'] = data.year
            Vue.prototype.storage.maskData['rk'] = data.rkNr
            // Vue.prototype.storage.maskData['waehrung'] = '' + cmp.ankerBank.bankCurrency
            Vue.prototype.$eventHub.$emit('otherYearSelected', Vue.prototype.storage.maskData['year'])
            Vue.prototype.$eventHub.$emit('otherRechtskreisSelected', Vue.prototype.storage.maskData['rechtskreis'])
            Vue.prototype.$eventHub.$emit('otherCurrencySelected', Vue.prototype.storage.maskData['waehrung'])
            cmp.ankerBankData = Vue.prototype.storage.getAnkerbankData(Vue.prototype.$api.getModuleId())
          } else {
            Vue.prototype.storage.maskData['waehrung'] = '2' // default for euro
            Vue.prototype.$eventHub.$emit('otherCurrencySelected', Vue.prototype.storage.maskData['waehrung'])
          }
        })
      },
      refreshI18N () {
        // console.log('refreshI18N')
        let cmp = this
        window.setTimeout(function () {
          cmp.rIndex++
          cmp.OnResize()
          cmp.onMountedDone()
        }, 1000)
      },
      reloadTabCauseLocale (data) {
        this.OnResize()
        this.onMountedDone()
      },
      pickFile () {
        this.$refs.image.click()
      },
      onFilePicked (e) {
        var cmp = this
        const files = e.target.files
        if (files[0] !== undefined) {
          this.imageName = files[0].name
          if (this.imageName.lastIndexOf('.') <= 0) {
            return
          }
          var fileName = files[0].name
          var index = fileName.indexOf('.json')
          if (index > -1) {
            index = fileName.indexOf('_')
            var hashValue = fileName.split('.')
            hashValue = hashValue[0].split('_')[1]
            if (index > -1) {
              const fr = new FileReader()
              fr.readAsDataURL(files[0])
              fr.addEventListener('load', () => {
                var data = fr.result
                data = data.substring('data:application/json;base64,'.length)
                data = base64.decode(data)
                data = JSON.parse(data)
                // data[0].searchMaskFields = JSON.parse(data[0].searchMaskFields)
                Vue.prototype.$api.importSearchFieldConfigurations(hashValue, data, cmp.onConfigImported)
              })
            }
          }
        } else {
          this.imageName = ''
          this.imageFile = ''
          this.imageUrl = ''
        }
      },
      doDeleteFilter () {
        Vue.prototype.$api.debug('deleteFilter', this.searchConfig)
        if (this.searchConfig) {
          var data = {
            'id': this.searchConfig
          }
          Vue.prototype.$api.deleteSearchFieldConfigurations(null, data, this.onFiltersetDeleted)
        }
      },
      deleteFilter () {
        const cmp = this
        var sc = this.getById(this.searchConfig)
        if (sc === null) {
          return
        }
        this.$refs.dlgDeleteItem.open({
          type: sc.text,
          id: '',
        })
      },
      onFiltersetDeleted (data) {
        Vue.prototype.$api.debug('onFiltersetDeleted')
        swal(Vue.i18n.translate('DIALOG_TEXT_SUCCESS_FILTER_SET_DELETED'))
        Vue.prototype.$api.getSearchFieldConfigurations(this.onGetSearchConfigurations)
      },
      onConfigImported (data) {
        Vue.prototype.$api.debug('onConfigImported')
        if (data.success) {
          swal(Vue.i18n.translate('DIALOG_TEXT_SUCCESS_IMPORT'))
        } else {
          swal(Vue.i18n.translate('DIALOG_TEXT_FAILED_IMPORT'))
        }
        Vue.prototype.$api.getSearchFieldConfigurations(this.onGetSearchConfigurations)
      }
    },
    created() {
      Vue.prototype.$api.debug('Add onSumbitMask2 EVENTS')
      Vue.prototype.$eventHub.$on('onPRZFromAnkerbank', this.onPRZFromAnkerbank)
      Vue.prototype.$eventHub.$on('onPRZToAnkerbank', this.onPRZToAnkerbank)
      Vue.prototype.$eventHub.$on('onSumbitMask2', this.onSumbitMask2)
      Vue.prototype.$eventHub.$on('onSumbitClear', this.onSumbitClear)
      Vue.prototype.$eventHub.$on('onChangeSearchMask', this.onChangeSearchMask)
      Vue.prototype.$eventHub.$on('doSearch', this.onDoSearch)
      Vue.prototype.$eventHub.$on('EventStoreSearchData', this.createSearchDataFromFields)
      Vue.prototype.$eventHub.$on('OnResize', this.OnResize)
      Vue.prototype.$eventHub.$on('setModuleDone', this.reloadTabCauseLocale)
      Vue.prototype.$eventHub.$on('I18NIsRefresh', this.refreshI18N)
    },
    destroyed() {
      Vue.prototype.$api.debug('Remove onSumbitMask2 EVENTS')
      Vue.prototype.$eventHub.$off('onPRZFromAnkerbank', this.onPRZFromAnkerbank)
      Vue.prototype.$eventHub.$off('onPRZToAnkerbank', this.onPRZToAnkerbank)
      Vue.prototype.$eventHub.$off('onSumbitMask2', this.onSumbitMask2)
      Vue.prototype.$eventHub.$off('onSumbitClear', this.onSumbitClear)
      Vue.prototype.$eventHub.$off('onChangeSearchMask', this.onChangeSearchMask)
      Vue.prototype.$eventHub.$off('doSearch', this.onDoSearch)
      Vue.prototype.$eventHub.$off('EventStoreSearchData', this.createSearchDataFromFields)
      Vue.prototype.$eventHub.$off('OnResize', this.OnResize)
      Vue.prototype.$eventHub.$off('setModuleDone', this.reloadTabCauseLocale)
      Vue.prototype.$eventHub.$off('I18NIsRefresh', this.refreshI18N)

    },
    mounted() {
      var cmp = this

      this.idModuleName = Vue.i18n.translate(this.idModule.toUpperCase() + '_TITLE')
      this.idModule = Vue.prototype.$api.getModuleId()

      /*
      let index = 0
      // this.wzcode = []
      this.wzcode = _.forEach(Vue.prototype.storage.getWZCodeData(), function (code) {
        code.id = '' + index
        code.name = '' + code.Branchenbezeichnung
        cmp.wzcode.push(code)
        index++
      })
      console.log('-wzcode', this.wzcode)
      */


      Vue.prototype.$api.checkCredentials(cmp, function () {
        cmp.attributeNameDynamic = 'dynamic'
        cmp.currencyList = Vue.prototype.storage.getCurrencyList()
        cmp.hasAnkerBank = Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())
        cmp.ankerBank = Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId())
        if (cmp.hasAnkerBank) {
          cmp.attributeNameDynamic = 'dynamicWithAnkerbank'
        }
        // console.log('ankerBank', cmp.hasAnkerBank, cmp.ankerBank, cmp)
        cmp.stopEventSearch = false
        cmp.clear()
        cmp.isPeerGroupSearch = cmp.balanceName === 'Peergroup'

        if (cmp.$route.params) {
          cmp.idModule = Vue.prototype.$api.getModuleId()
          cmp.idModuleItem = cmp.$route.params.idModuleItem

          cmp.maskDataName = cmp.maskDataName + '_' + cmp.idModule
          if (cmp.isPeerGroupSearch) {
            cmp.maskDataName = cmp.maskDataName + '_Peergroup'
          }
          Vue.prototype.storage.maskData = Vue.prototype.storage.getStorage(cmp.maskDataName, [])
          // Vue.prototype.storage.maskData = Vue.prototype.storage.getState(this.maskDataName, {})
          cmp.updateSearchMask()
        }
        cmp.target = cmp.idModule + cmp.balanceName
        Vue.prototype.$api.debug('maskData', Vue.prototype.storage.maskData, cmp.target)

        cmp.checkboxTextBalanceAvailable  = Vue.i18n.translate(Vue.prototype.$api.getModuleId().toUpperCase() + '_TITLE_CHECKBOX_WO_BALANCE')

        cmp.OnResize()
        cmp.onMountedDone()
      })

    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/mask/SearchMaskv2.vue